import { inject } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { periodOptions, VIEWERS_STORE } from 'store'
import {
  SortTabs
} from './SortTabs'
import styles from './ViewersPage.module.scss'
import cl from 'classnames'
import {
  ViewersPageProps
} from './ViewersPage.types'
import { ViewersTable } from './ViewersTable'
import {
  Button, CurrencySelector, PageHeader,
  PageHeaderPeriodPicker, VerticalLine
} from 'components/shared'
import { IconDownload, IconPrint, IconViewers } from 'assets'
import { observer } from 'mobx-react-lite'
import { ViewersStatistics } from './ViewersStatistics'
import { useGetIsResponsiveScreen } from 'utilities'

const ViewersPageComponent = (props: ViewersPageProps) => {
  const {
    [VIEWERS_STORE]: {
      getViewers,
      filterPeriod,
      onFilterPeriodChange,
      searchPeriod,
      onSearchPeriodChange
    }
  } = props
  const { isResponsive: isLargeMobile } = useGetIsResponsiveScreen('(max-width: 920px)')

  useEffect(getViewers, [getViewers])

  return (
    <div className={cl(styles.container, styles.scrollable)} style={{ overflowX: 'hidden' }}>
      <PageHeader
        navSegments={[{
          label: 'Viewers',
          icon: IconViewers,
          iconProps: {
            width: 40,
            style: {
              paddingTop: 10
            }
          }
        }]}
        buttonsContainerChildren={(
          <>
            <div className={styles.buttonsContainer}>
              <div className={styles.currencySelectorContainer}>
                <CurrencySelector />
                <VerticalLine style={{ margin: '0 30px 0 35px' }} />
              </div>
              <div className={styles.periodPickerContainer}>
                <PageHeaderPeriodPicker
                  selectProps={{
                    options: periodOptions,
                    value: filterPeriod,
                    onChange: onFilterPeriodChange
                  }}
                  periodPickerProps={{
                    period: searchPeriod,
                    setPeriod: onSearchPeriodChange
                  }}
                />
                <Button
                  className={styles.headerButton}
                  preset='icon'
                  disabled
                >
                  <IconDownload />
                </Button>
                <Button
                  className={styles.headerButton}
                  preset='icon'
                  disabled
                >
                  <IconPrint />
                </Button>
              </div>
            </div>
          </>
        )}
        style={ { zIndex: 3 } }
      />
      <ViewersStatistics />
      <SortTabs style={{ marginTop: '30px' }} />
      <ViewersTable style={ { overflow: 'auto' } } className={styles.thinScroll} />
    </div>
  )
}

const ViewersPage = inject(VIEWERS_STORE)(observer(ViewersPageComponent))
export { ViewersPage }
